import gql from 'graphql-tag';

export const SaveRecipientMutation = gql`
mutation ($recipientInput: RecipientInput!, $recipientId: String,$applicationId:String) {
  saveRecipient (recipient: $recipientInput, recipientId: $recipientId,applicationId:$applicationId) 
  {
    id
    signingStatus
  }
}`;